import { Children } from "react";

import { cn } from "@/shared/helpers/cn.helper";

export const TableRow: React.FC<React.ComponentProps<"tr">> = ({
  className,
  children,
  ...props
}) => {
  // Filter out whitespace-only text nodes to prevent hydration errors
  const filteredChildren = Children.toArray(children).filter((child) => {
    if (typeof child === "string") {
      return child.trim().length > 0;
    }
    return true;
  });

  return (
    <tr
      className={cn(
        "hover:bg-muted/50 data-[state=selected]:bg-muted transition-colors",
        className,
      )}
      data-slot="table-row"
      {...props}
    >{filteredChildren}</tr>
  );
};
